import { nomeParaSigla } from './Enums/NomeParaSigla';

export function getSiglaSeExistir(nomeEstado: string): string | null {
  const normalizar = (str: string): string =>
    str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
      .trim();

  const nomeNormalizado = normalizar(nomeEstado);

  const sigla = nomeParaSigla[nomeNormalizado];

  if (!sigla) return null;

  return sigla;
}
